import type { ReactNode } from "react";
import { RapportkatalogCardLabelAndText } from "./RapportkatalogCardLabelAndText";
import "./RapportkatalogCardInfo.css";

type RapportkatalogCardInfoItem = {
    label: string;
    value: ReactNode;
};

type RapportkatalogCardInfoProps = {
    items: RapportkatalogCardInfoItem[];
};

export function RapportkatalogCardInfo({ items }: RapportkatalogCardInfoProps) {
    return (
        <div className="rapportkatalog-card-info">
            {items.map((item) => (
                <div key={item.label} className="rapportkatalog-card-info-item">
                    <RapportkatalogCardLabelAndText label={item.label} value={item.value} />
                </div>
            ))}
        </div>
    );
}
